//Счетчик
export const Counter = {
    emits: [],
    props: {
        modelValue: {
            type: Number
        },
        unit: {
            type: String,
            default: 'шт'
        },
        max: {
            type: Number,
            default: Number.MAX_VALUE
        },
        maxQuantity: {
            type: Number,
            default: 1
        },
        min: {
            type: Number,
            default: 0
        },
        ratio: {
            type: Number,
            default: 1
        },
        desc: {
            type: String,
            default: ''
        },
        callback: {
            type: Promise
        },
        debounce: {
            type: Number,
            default: 600
        }
    },
    data() {
        return {
            value: 0,
            tm: null,
            isLoader: false
        }
    },
    computed: {},
    mounted() {
        this.value = this.modelValue;
    },
    methods: {
        plus() {
            this.value = parseFloat(this.value);
            if (this.value + this.ratio <= this.maxQuantity) {
                this.value += this.ratio;
                this.value = parseFloat(this.value);
                this.change(this.debounce);
            }
        },
        minus() {
            this.value -= this.ratio;

            this.value = Math.round(this.value * 1000) / 1000;

            if (this.value > this.min && this.value < this.ratio) {
                this.value = this.ratio;
            }

            if (this.value < this.min)
                this.value = this.min;

            if (this.value)
                this.change(this.debounce);
            else
                this.change(0);
        },
        change(debounce) {
            if (this.tm)
                clearTimeout(this.tm);

            this.tm = setTimeout(() => {
                if (this.callback) {
                    this.isLoader = true;
                    this.callback(this.value).catch(() => {
                        this.value = this.modelValue;
                    }).finally(() => {
                        this.isLoader = false;
                    });
                }
            }, debounce);
        },
        changeValue() {
            if (this.value <= 0) {
                this.value = 0;
            } else if (this.value > this.maxQuantity) {
                this.value = this.maxQuantity;
                this.value = parseFloat(this.value);
            }
            this.change(this.value);
        },
    },
    watch: {
        modelValue(val) {
            const qty = Number(val);
            if (qty > 0) {
                this.value = qty;
            } else {
                this.value = 0;
            }
        },
    },
    template: `
<div class="counter-block big">
		<span class="minus dark-color" :disabled="isLoader || value==min" @click="minus()">
			<i class="svg inline svg-inline-wish ncolor colored1" aria-hidden="true"><svg width="11" height="1" viewBox="0 0 11 1"><rect width="11" height="1" rx="0.5" ry="0.5"></rect></svg></i>                    
		</span>
		<span class="text"><div class="counter__info">
			  <div class="counter__info-value"><input type="number" @change="changeValue()" v-model="value"> <!--{{unit}}--></div>
			  <div class="counter__info-description">{{desc}}</div>
			</div></span>
		<span class="plus dark-color" :disabled="isLoader || value>=maxQuantity" @click="plus()">
			<i class="svg inline  svg-inline-wish ncolor colored1" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 11 11"><path d="M1034.5,193H1030v4.5a0.5,0.5,0,0,1-1,0V193h-4.5a0.5,0.5,0,0,1,0-1h4.5v-4.5a0.5,0.5,0,0,1,1,0V192h4.5A0.5,0.5,0,0,1,1034.5,193Z" transform="translate(-1024 -187)"></path></svg></i>                    
		</span>
		</div>
`
};
